import { LitElement } from "lit";
import { emit } from "../utilities/events.js";
class LeafElement extends LitElement {
  emit(name, options, element) {
    return emit(name, options, element || this);
  }
}
export {
  LeafElement
};
//# sourceMappingURL=leaf-element.js.map
